import { apiCreate, apiGetList, apiUpdate } from './ApiBaseActions';
export const API_GET_PROFFIT_SEARCH_SLIDE_FOLDER = 'API_GET_PROFFIT_SEARCH_SLIDE_FOLDER';
export const API_CREATE_PROFFIT_SEARCH_SLIDE_FOLDER = 'API_CREATE_PROFFIT_SEARCH_SLIDE_FOLDER';
export const API_UPDATE_PROFFIT_SEARCH_SLIDE_FOLDER = 'API_UPDATE_PROFFIT_SEARCH_SLIDE_FOLDER';
export const API_UPDATE_PROFFIT_SEARCH_SLIDE_FOLDER_RENAME = 'API_UPDATE_PROFFIT_SEARCH_SLIDE_FOLDER_RENAME';
export const API_UPDATE_PROFFIT_SEARCH_SLIDE_FOLDER_RENAME_SUCCESS = 'API_UPDATE_PROFFIT_SEARCH_SLIDE_FOLDER_RENAME_SUCCESS';
/**
 * フォルダの一覧の取得
 * @param data
 * @param meta
 * @returns {{payload: {}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: *}, type: *}}
 */
export const apiGetListProffitSearchFolder = (data, meta) => apiGetList(API_GET_PROFFIT_SEARCH_SLIDE_FOLDER, '/proffit_search/folder', data, meta);
/**
 * フォルダの追加
 * @param data
 * @param meta
 * @returns {{payload: {data: *}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: string}, type: string}}
 */
export const apiCreateProffitSearchFolder = (data, meta) => apiCreate(API_CREATE_PROFFIT_SEARCH_SLIDE_FOLDER, '/proffit_search/folder', data, meta);
/**
 * 選択したスライドをフォルダに保存する
 * @param id
 * @param data
 * @param meta
 * @returns {{payload: {data: *}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: string}, type: string}}
 */
export const apiUpdateProffitSearchFolder = (id, data, meta) => apiUpdate(API_UPDATE_PROFFIT_SEARCH_SLIDE_FOLDER, `/proffit_search/folder/${id}/select`, data, meta);
/**
 * 選択したフォルダの名称をリネームする
 * @param id
 * @param data
 * @param meta
 * @returns {{payload: {data: *}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: *}, type: *}}
 */
export const apiUpdateProffitSearchFolderRename = (id, data, meta) => apiUpdate(API_UPDATE_PROFFIT_SEARCH_SLIDE_FOLDER_RENAME, `/proffit_search/folder/${id}/rename`, data, meta);
